import { Control } from "../../business-objects/control/control.model";
import { RegLookupControlConfig } from "./reg-lookup-control-config.model";

export class RegLookupControl extends Control {
    config: RegLookupControlConfig;
}



// WEBPACK FOOTER //
// ./src/vas/controls/reglookup/reg-lookup-control.model.ts